export const varNameReg = /\{%\s+var\s+.*%\}/;
export const equalReg = /[^b]=/;
export const varReg = /\{%\s*var\s+(?<name>[\w_]*)\s*(?<filters>\|.*)\s*%\}/;
